var moduleMap = {
	"./FDE": () => {
		return Promise.all([__webpack_require__.e(1991), __webpack_require__.e(318), __webpack_require__.e(4565), __webpack_require__.e(6737), __webpack_require__.e(5138), __webpack_require__.e(5437)]).then(() => (() => ((__webpack_require__(831)))));
	},
	"./Supervisor": () => {
		return Promise.all([__webpack_require__.e(1991), __webpack_require__.e(318), __webpack_require__.e(4565), __webpack_require__.e(6737), __webpack_require__.e(5138), __webpack_require__.e(3475)]).then(() => (() => ((__webpack_require__(5138)))));
	},
	"./QuickSupervisor": () => {
		return Promise.all([__webpack_require__.e(1991), __webpack_require__.e(318), __webpack_require__.e(4565), __webpack_require__.e(6737), __webpack_require__.e(5138), __webpack_require__.e(7068), __webpack_require__.e(4581)]).then(() => (() => ((__webpack_require__(4581)))));
	},
	"./mount": () => {
		return Promise.all([__webpack_require__.e(1991), __webpack_require__.e(318), __webpack_require__.e(4565), __webpack_require__.e(6737), __webpack_require__.e(5138), __webpack_require__.e(7068), __webpack_require__.e(3727)]).then(() => (() => ((__webpack_require__(3727)))));
	},
	"./quickMount": () => {
		return Promise.all([__webpack_require__.e(1991), __webpack_require__.e(318), __webpack_require__.e(4565), __webpack_require__.e(6737), __webpack_require__.e(5138), __webpack_require__.e(7068), __webpack_require__.e(3736)]).then(() => (() => ((__webpack_require__(3736)))));
	},
	"./api": () => {
		return Promise.all([__webpack_require__.e(6737), __webpack_require__.e(8442)]).then(() => (() => ((__webpack_require__(7134)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});